<template>
  <v-app>
    <toolbars v-if="usuario != null"></toolbars>
    <v-main class="pb-5">
      <router-view/>
    </v-main>
  </v-app>
</template>

<script>
import { mapState } from 'vuex';
import toolbars from './components/toolbars.vue'
export default {
  name: 'App',

  data: () => ({
    //
  }),
  components:{
    toolbars
  },
  computed:{
    ...mapState(['usuario'])
  }
};
</script>
